import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface PartyScreenState {
    inlineEditingCandidateId: string | null;
    addMode: boolean;
    validationErrorsForCandidate: { [candidateId: string]: string[] | undefined };
}

const partyScreenSlice = createSlice({
    name: 'SLICE_PartyScreen',
    initialState: {
        inlineEditingCandidateId: null,
        addMode: false,
        validationErrorsForCandidate: {},
    } as PartyScreenState,
    reducers: {
        candidateInlineEdited(state, action: PayloadAction<{ candidateId: string | null }>) {
            return { ...state, inlineEditingCandidateId: action.payload.candidateId };
        },
        addModeSet(state, action: PayloadAction<{addMode: boolean}>) {
            return {
                ...state,
                addMode: action.payload.addMode,
                getInlineEditingCandidateId: action.payload.addMode ? state.inlineEditingCandidateId : null
            };
        },
        candidateInlineValidatedErrors(state, action: PayloadAction<{ id: string, errors: string[] }>) {
            return {
                ...state,
                validationErrorsForCandidate: {
                    ...state.validationErrorsForCandidate,
                    [action.payload.id]: action.payload.errors,
                },
            };
        },
    },
});

export const {
    candidateInlineEdited,
    addModeSet,
    candidateInlineValidatedErrors,
} = partyScreenSlice.actions

export default partyScreenSlice.reducer
